
var Model = require("../types/Model.js");

/**
 * This model represents the list of all missed messages from peopel
 * @type {[type]}
 */
module.exports = Model({
	name: "livechatmissedmessage",
	init: init,
	listeners: listeners,
	handle_unread_update: handle_unread_update
});

function init() {
	this.push({});
}

/**
 * Sets up listeners for changes in connectivity, and for when messages are read
 * @return {Object}  Returns an object with events mapping to listeners
 */
function listeners() {
	return {
		"unreadnotifications:updated": handle_unread_update
	};
}

function handle_unread_update(unread){
	var unreadMessages = unread.filter(function(item){
		var isUnreadMessage = item.type.indexOf("livechat:message") !== -1;
		if(isUnreadMessage)	return isUnreadMessage;
	}.bind(this));
	var processedMessages = process_messages(unreadMessages);
	this.push(processedMessages);
}


/**
 * Processes raw list of messages and counts occurences by who they were from
 * @param  {Array}  messages Array of messages containing who it was `from`
 * @return {Object}          Returns a map of from ids to # of occurences
 */
function process_messages(messages) {
	return messages.reduce(count_by_id, {
		total: 0
	});
}

/**
 * Adds to the counter for the current person the message was from
 * @param  {Object}  result  The aggregation object. A map of user ids to counters
 * @param  {Message} current The current message to process
 * @return {Object}          The aggregation object
 */
function count_by_id(result, current) {
	var id = current.group._id;
	result[id] = (result[id] || 0) + 1;
	result["total"]++;
	return result;
}
